/* jshint esversion: 6 */

class HaciendolaMegaMenu extends HTMLElement {
  constructor() {
    super();
    const menuItems = [
      ...document.querySelectorAll('.navmenu .header__inline-menu li'),
    ];
    this.label = this.dataset.trigger?.trim();
    if (!this.label) return;
    
    this.linkTitle = this.label.toLowerCase();
    this.summary = undefined;
    this.trigger = menuItems.find(item => {
      const summary = item.querySelector('summary');
      const search = (summary || item).textContent.toLowerCase().trim();
      if (summary) this.summary = summary;
      if (summary && summary.nextElementSibling) summary.nextElementSibling.remove();
      return search === this.linkTitle;
    });
    if (!this.trigger) {
      // Silently return if trigger not found (may not be on this page)
      return;
    }
    menuItems.forEach(item => {
      if (item === this.trigger) return;
      item.addEventListener('mouseenter', () => {
        this.hide();
      });
    });
    this.enableCaret = this.dataset.enableCaret === 'true' ? true : false;
    this.parent = this.trigger.closest('.navmenu');
    if (!this.parent) {
      return;
    }
    const lnk = this.trigger.querySelector('a') || this.trigger.querySelector('summary');
    if (lnk) {
      lnk.style.display = 'flex';
      lnk.style.gap = '.3em';
      lnk.style.alignItems = 'center';
      lnk.innerHTML = `<span ${this.enableCaret ? 'class="h-megamenu-trigger-caret"' : ''}>${this.label}</span>`;
    }
    this.parent.appendChild(this);
    if (this.classList.contains('h-megamenu--fullwidth')) {
      this.style.width = `${window.innerWidth}px`;
    }
    this.trigger.addEventListener('click', e => {
      e.preventDefault();
    });
    this.trigger.addEventListener('mouseenter', () => this.show());
    this.addEventListener('mouseenter', () => this.show());
    this.addEventListener('mouseleave', e => this.hide(e), false);
  }
  show() {
    const openedMM = this.parent.openedMM;
    if (openedMM && openedMM !== this) openedMM.hide();
    this.parent.openedMM = this;
    const top = this.trigger.offsetTop + this.trigger.offsetHeight;
    this.style.setProperty('--top-position', `${top}px`);
    this.style.display = 'grid';
    this.trigger.classList.add('h-megamenu--trigger');
  }
  hide(e) {
    if (!e || e.target === this || e.target === this.trigger) {
      this.style.display = 'none';
      this.trigger.classList.remove('h-megamenu--trigger');
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  customElements.define('h-megamenu', HaciendolaMegaMenu);
});